import ApiService from "@/core/services/api.service";
// action types
export const GET_NOTIFICACIONES = "getNotificaciones";
export const UPDATE_NOTIFICACION = "updateNotificacion";
// mutation types
export const SET_ERROR = "setError";
export const SET_NOTIFICACIONES = "setNotificaciones";

const state = {
  errors: [],
  notificaciones:{}
};

const actions = {
  [GET_NOTIFICACIONES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Notificacion/v1/mibricsa/notificaciones`}, '')
        .then(({ data }) => {
          context.commit(SET_NOTIFICACIONES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [UPDATE_NOTIFICACION](context, notificacion) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.post({action:`/gateway/Notificacion/v1/mibricsa/notificacion/leida`}, notificacion)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_NOTIFICACIONES](state, data) {
    state.errors = [];
    state.notificaciones = data;
  }
};

export default {
  state,
  actions,
  mutations
};
